import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useEffect } from "react";
import { loadMyListData, loadRecentContactsData } from "../redux/action";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";

const RecentActivities = ({ pageStatus, setPageStatus, type }) => {
    const { loginDetails } = useSelector(state => state.data);
    const { screenWidth } = useSelector(state => state.data);
    const { get_uplaoads } = useSelector(state => state.data);
    const { userActivityData } = useSelector(state => state.data);
    const { userDownloadData } = useSelector(state => state.data);

    const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
    const signInID = signInDetails[0]?.id;
    const sbnID = signInDetails[0]?.sbn_id;
    const role = signInDetails[0]?.role;
    const { myListData } = useSelector((state) => state.data);
    const { getRecentContacts } = useSelector((state) => state.data);

    const dispatch = useDispatch();

    useEffect(() => {
        if (pageStatus) return;
        setPageStatus(true)
        if (type === "lists") {
            dispatch(loadMyListData(signInID, sbnID, role, 1, 20));
        } else if (type === "viewed") {
            dispatch(loadRecentContactsData(signInID, sbnID, "Default", role, 1, 20))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type, pageStatus])

    const findSpentTime = (loginDate, loginTime, logoutTime) => {
        if (logoutTime === "-") return <span>Still logged in</span>;

        const format = "DD-MMM-YYYY HH:mm:ss";

        const login = moment(`${loginDate} ${loginTime}`, format);
        const logout = moment(`${loginDate} ${logoutTime}`, format);

        if (!login.isValid() || !logout.isValid()) return <span>Invalid time</span>;

        const duration = moment.duration(logout.diff(login));

        const hours = String(Math.floor(duration.asHours())).padStart(2, '0');
        const minutes = String(duration.minutes()).padStart(2, '0');
        const seconds = String(duration.seconds()).padStart(2, '0');

        const formattedTime = `${hours}:${minutes}:${seconds}`;

        return <span>{formattedTime}</span>;
    };

    const EmptyState = () => (
        <div className="activity-empty-state">
            <div className="activity-empty-icon">
                <i className='bx bx-history'></i>
            </div>

            <h5>No Recent Activity</h5>

            <p>
                Activities will appear here when users
                interact with the platform.
            </p>
        </div>
    );

    const ActivityCard = ({
        icon,
        iconClass,
        name,
        company,
        title,
        time,
        status
    }) => (
        <div className="activity-card">
            <div className={`activity-avatar ${iconClass}`}>
                <i className={icon}></i>
            </div>
            <div className="activity-content">
                <div className="activity-header">
                    <div>
                        <h6>{name}</h6>

                        {company && (
                            <span className="activity-company">
                                {company}
                            </span>
                        )}
                    </div>

                    {status && (
                        <span className={`activity-status ${status.class}`}>
                            {status.label}
                        </span>
                    )}
                </div>
                <p className="activity-description">
                    {title}
                </p>
                <div className="activity-footer">
                    <span className="activity-time">
                        <i className='bx bx-time-five'></i>
                        {time}
                    </span>
                </div>
            </div>
        </div>
    );

    const ListCard = ({
        icon,
        iconClass,
        listName,
        count,
        createdAt
    }) => (
        <div className="activity-card list-card d-flex align-items-center">
            <div className={`activity-avatar ${iconClass}`}>
                <i className={icon}></i>
            </div>

            <div className="flex-grow-1 d-flex justify-content-between align-items-center">
                <div className="text-truncate">
                    <strong>{listName}</strong>
                    <span className="text-muted ms-2">
                        • {count} Contacts
                    </span>
                </div>

                <small className="text-muted ms-3">
                    {createdAt}
                </small>
            </div>
        </div>
    );


    return (
        <Row className="recent-activity-container-row">
            <Col md={12} className="recent-activity-container-col" >
                {type === "sessions" ? (
                    <>{loginDetails.length !== 0 &&
                        <>
                            <div className="recent-activity-container-first-tab-container">
                                {loginDetails.length > 0 ? (
                                    loginDetails.map((login, index) => (
                                        <ActivityCard
                                            icon="bx bx-user-circle"
                                            iconClass="session"
                                            name={login.name}
                                            company={login.company_name}
                                            title={`Session Duration: ${login.logout_time !== "-"
                                                ? findSpentTime(
                                                    login.login_date,
                                                    login.login_time,
                                                    login.logout_time
                                                )
                                                : "Still Active"
                                                }`}
                                            time={`Login ${moment(
                                                login.login_time,
                                                'HH:mm:ss'
                                            ).format('hh:mm A')
                                                }`}
                                            status={{
                                                label:
                                                    login.logout_time === "-"
                                                        ? "Online"
                                                        : "Offline",
                                                class:
                                                    login.logout_time === "-"
                                                        ? "online"
                                                        : "offline"
                                            }}
                                        />
                                    ))
                                ) : (
                                    <EmptyState />
                                )}
                            </div>
                        </>
                    }</>
                ) : type === "upload" ? (
                    <>
                        <div className="recent-activity-container-first-tab-container">
                            {get_uplaoads.length > 0 ? (
                                get_uplaoads.slice(0, 10).map((uploads, index) => (
                                    <ActivityCard
                                        icon="bx bx-upload"
                                        iconClass="upload"
                                        name={uploads.username}
                                        title={`Uploaded ${uploads.fresh + uploads.repeated
                                            } contacts (${uploads.fresh} fresh)`}
                                        time={moment(
                                            uploads.uploaded_date
                                        ).format(
                                            "DD MMM YYYY • hh:mm A"
                                        )}
                                    />
                                ))
                            ) : (
                                <EmptyState />
                            )}
                        </div>
                    </>
                ) : type === "downloads" ? (
                    <>
                        <div className="recent-activity-container-first-tab-container">
                            {userDownloadData.length > 0 ? (
                                <Row className="m-0">
                                    {userDownloadData.slice(0, 10).map((download, index) => (
                                        <Col sm={12} md={(screenWidth > 0 && screenWidth) < 1441 ? 12 : 6}
                                            lg={(screenWidth > 0 && screenWidth) < 1441 ? 12 : 6} key={index}>
                                            <ActivityCard
                                                icon="bx bx-download"
                                                iconClass="download"
                                                name={download.user_name}
                                                title={`Downloaded ${download.count} contacts`}
                                                time={moment(download.date).format(
                                                    "DD MMM YYYY • hh:mm A"
                                                )}
                                            />
                                        </Col>
                                    ))}
                                </Row>
                            ) : (
                                <EmptyState />
                            )}
                        </div>
                    </>
                ) : type === "activities" ? (
                    <>
                        <div className="recent-activity-container-first-tab-container">
                            {userActivityData.length > 0 ? (
                                userActivityData.slice(0, 10).map((activity, index) => (
                                    <ActivityCard
                                        icon="bx bx-pulse"
                                        iconClass="activity"
                                        name={activity.user_name}
                                        title={`Downloaded ${activity.count} contacts`}
                                        time={moment(
                                            activity.date,
                                            "DD-MMM-YYYY"
                                        ).format("DD MMM YYYY")}
                                    />
                                ))
                            ) : (
                                <EmptyState />
                            )}
                        </div>
                    </>
                ) : type === "lists" ? (
                    <>
                        <div className="recent-activity-container-first-tab-container">
                            {myListData.length > 0 ? (
                                <Row className="m-0">
                                    {myListData.slice(0, 10).map((lists, index) => (
                                        <Col sm={12} md={(screenWidth > 0 && screenWidth) < 1441 ? 12 : 6}
                                            lg={(screenWidth > 0 && screenWidth) < 1441 ? 12 : 6} key={index}>
                                            <ListCard
                                                icon="bx bx-list-ul"
                                                iconClass="activity"
                                                listName={lists.list_name}
                                                count={lists.viewed_count}
                                                createdAt={moment(lists.list_created_datetime).format("DD MMM YYYY")}
                                            />
                                        </Col>
                                    ))}
                                </Row>
                            ) : (
                                <EmptyState />
                            )}
                        </div>
                    </>
                ) : type === "viewed" ? (
                    <>
                        <div className="recent-activity-container-first-tab-container">
                            {getRecentContacts.length > 0 ? (
                                <Paper className='recent-search-paper'>
                                    <TableContainer className='recent-section'
                                        sx={{
                                            height: 410,
                                            overflow: "auto",
                                            width: "100%",
                                        }}>

                                        <Table stickyHeader size="small">

                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ minWidth: 180 }}>
                                                        Name
                                                    </TableCell>

                                                    <TableCell width="180">
                                                        Title
                                                    </TableCell>
                                                    <TableCell width="180">
                                                        Email
                                                    </TableCell>
                                                    <TableCell width="180">
                                                        Phone
                                                    </TableCell>
                                                    <TableCell width="180">
                                                        Country
                                                    </TableCell>

                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {getRecentContacts.slice(0, 10).map((lists, index) => (
                                                    <TableRow
                                                        key={index}
                                                        className="recent-search-row"
                                                    >
                                                        <TableCell>
                                                            <span className="user-badge">
                                                                {lists.firstname + " " + lists.lastname}
                                                            </span>
                                                        </TableCell>
                                                        <TableCell>
                                                            {lists.job_title}
                                                        </TableCell>
                                                        <TableCell>
                                                            {lists.email}
                                                        </TableCell>
                                                        <TableCell>
                                                            {lists.phone}
                                                        </TableCell>
                                                        <TableCell>
                                                            {lists.country}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Paper>
                            ) : (
                                <EmptyState />
                            )}
                        </div>
                    </>
                ) : null}
            </Col>
        </Row>
    );
};

export default RecentActivities;
